import React from "react";
import Careers from "../../../components/careers/Careers";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getRouteLocalizationNamespaces } from "../../../methods/getRouteLocalizationNamespaces";

import {
    getCareerHomePageStaticProps,
    getCareersHomePageLayout
} from "components/careers/careers-page-constants-methods";
export default function CareersWeb(props: any) {
    return <Careers {...props} />;
}

CareersWeb.getLayout = getCareersHomePageLayout;

export async function getStaticProps(context: any) {
    return {
        props: {
            isMobile: false,
            ...(await serverSideTranslations(context.locale, getRouteLocalizationNamespaces("careers"))),
            ...(await getCareerHomePageStaticProps())
        }
    };
}
